import React from "react";
import { PdsFooter, PdsLink } from "@principal/design-system-react";
import { DateTime } from "luxon";

interface FooterProps {
    children?: React.ReactNode;
}

const Footer = (props: FooterProps) => {
    return (
        <div>
            <PdsFooter className="pds-u-margin-top-20">
                <div slot="legal-text">
                    <div>©{DateTime.now().year} Principal Financial Services, Inc.</div>
                    {props.children}
                    <div>
                        Securities offered through Principal Securities, Inc., <PdsLink href="https://www.sipc.org" target="_blank" size="sm" variant="emphasis-inverted">member SIPC</PdsLink>
                    </div>
                </div>
            </PdsFooter>
        </div>
    );
}
export default Footer;
